export const Select = {
  baseStyle: {
    customDropdownIconProps: {
      size: '6',
      p: '1',
      pl: '0',
      color: 'trueGray.400',
    },
    _actionSheetContent: {},
  },
  defaultProps: {
    variant: 'outline',
  },
};

// SelectIcon - only for custom variant
export const SelectItem = {
  baseStyle: {
    p: '1',
    px: '2',
    borderRadius: '0',
    minH: '0',
  },
};
